import { TmplAstDeferredBlockPlaceholder } from '@angular/compiler';
import { Component, EventEmitter, Input, OnDestroy, Output, SimpleChanges } from '@angular/core';
import { AbstractControl, FormControl } from '@angular/forms';
import {
  BehaviorSubject,
  Subject,
  catchError,
  debounceTime,
  distinctUntilChanged,
  switchMap,
  of,
  filter,
  takeUntil,
} from 'rxjs';
import { RegistryItem } from 'src/app/api/models';
import { RegistryService } from 'src/app/api/services';

@Component({
  selector: 'app-input-registry-picker',
  templateUrl: './input-registry-picker.component.html',
  styleUrls: ['./input-registry-picker.component.scss'],
})
export class InputRegistryPickerComponent implements OnDestroy {
  @Input() frmControl?: AbstractControl;
  // _frmControl?: FormControl;
  filterRegistries$ = new BehaviorSubject<string>('');
  private destroy$ = new Subject<void>();
  // initial value or autocomplete value
  @Input() registries?: RegistryItem[];

  @Input() placeholder?: string;
  @Input() contactTypes?: number[];

  constructor(private registryService: RegistryService) {}

  ngOnInit() {
    this.filterRegistries$
      .pipe(
        debounceTime(300),
        filter(v => v.length > 0),

        switchMap(query =>
          // l'errore va gestito qui dentro: se arrivasse al subscribe chiuderebbe lo stream e
          // le ricerche successive non partirebbero più
          this.registryService
            .registryControllerGetAll({
              limit: 10,
              skip: 0,
              query,
              contact_types: this.contactTypes,
            })
            .pipe(catchError(() => of(null)))
        ),
        takeUntil(this.destroy$)
      )
      .subscribe({
        next: res => {
          if (res) this.registries = res.data.list;
        },
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngAfterViewInit() {
    // this._frmControl = this.frmControl as FormControl;
  }

  get _frmControl() {
    return this.frmControl as FormControl;
  }
}
